import { useQuery } from "@tanstack/react-query";

import { AvatarList } from "@/components/canvas-editor/components/AvatarList";
import { BlockSeparator } from "@/components/canvas-editor/components/Container";
import { RelationshipType } from "@/components/canvas-editor/shapes/shapes";
import { Spinner } from "@/components/Spinner";
import { getUserCollectionQueryOptions } from "@/lib/api";

export function SocialGraphPreview({
  username,
  direction,
}: {
  username: string;
  direction: RelationshipType;
}) {
  const { data: list, isPending } = useQuery(
    getUserCollectionQueryOptions(username, direction),
  );

  return (
    <>
      {list && list.asset_metadata ? (
        <>
          <BlockSeparator />
          <AvatarList
            users={list.asset_metadata}
            total={list.asset_value.length}
          />
        </>
      ) : isPending ? (
        <div className="flex justify-center items-center p-2 h-8">
          <Spinner delay={1000} />
        </div>
      ) : (
        <div className="text-sm text-slate-11 dark:text-slatedark-11 p-2">
          This user is not yet in our system. Please verify the username and
          wait a few minutes for it to be indexed.
        </div>
      )}
    </>
  );
}
